import { paymentConstants } from '../utils/types';

export default function payment(state = {}, action) {
  switch (action.type) {
  case paymentConstants.SET_PAYMENT_STATUS:
    return {
      paymentStatus: action.payload.paymentStatus,
      token: action.payload.token
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentReducer.js